import Container from "../core/Container"
import Paragraph from "../core/Paragraph"
import Button from "../core/Button"
import SectionTag from "../core/SectionTag"

export default function ContactForm({ onSubmit }){

    return(
        <section id="kontaktujte_nas">
            <Container bgColor="transparent" className="w-full py-16 md:py-24">
                <Container bgColor="transparent" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <SectionTag className="flex w-full justify-center">
                        Kontaktujte nás
                    </SectionTag>

                    <Container bgColor="main_light" className="flex py-4 px-4 sm:px-2 mt-2 items-center justify-center mb-2 rounded-lg shadow-md text-center">
                        <Paragraph variant="lead">💡Pokud budete mít zájem například o vzdělávací akci na objednávku, tak se neváhejte ozvat!</Paragraph>
                    </Container>
                
                    <Container>
                        <form onSubmit={onSubmit} action="#" method="POST" className="space-y-4 p-8 rounded-2xl border-2 border-main shadow-lg shadow-main/20">
                            <Container className="flex flex-col gap-2" bgColor="transparent">
                                <label className="font-medium text-gray-800">Jméno <span className="text-red-500">*</span></label>
                                <input id="name" type="text" name="name" autoComplete="given-name" required className="bg-white/90 border-2 border-gray-300 rounded-xl py-2 px-4 focus:border-main focus:bg-white focus:shadow-lg focus:outline-none transform hover:-translate-y-1 transition-all duration-300"></input>
                            </Container>

                            <Container className="flex flex-col gap-2" bgColor="transparent">
                            <label className="font-medium text-gray-800">Příjmení <span className="text-red-500">*</span></label>
                            <input id="surname" type="text" name="surname" autoComplete="family-name" required className="bg-white/90 border-2 border-gray-300 rounded-xl py-2 px-4 focus:border-main focus:bg-white focus:shadow-lg focus:outline-none transform hover:-translate-y-1 transition-all duration-300"></input>
                            </Container>

                            <Container className="flex flex-col gap-2" bgColor="transparent">
                            <label className="font-medium text-gray-800">Společnost</label>
                            <input id="company" type="text" name="company" autoComplete="organization" className="bg-white/90 border-2 border-gray-300 rounded-xl py-2 px-4 focus:border-main focus:bg-white focus:shadow-lg focus:outline-none transform hover:-translate-y-1 transition-all duration-300"></input>
                            </Container>

                            <Container className="flex flex-col gap-2" bgColor="transparent">
                                <label className="font-medium text-gray-800">Email <span className="text-red-500">*</span></label>
                                <input id="email" type="email" name="email" autoComplete="email" required className="bg-white/90 border-2 border-gray-300 rounded-xl py-2 px-4 focus:border-main focus:bg-white focus:shadow-lg focus:outline-none transform hover:-translate-y-1 transition-all duration-300"></input>
                            </Container>
                            
                            <Container className="flex flex-col gap-2" bgColor="transparent">
                            <label className="font-medium text-gray-800">Telefon <span className="text-red-500">*</span></label>
                            <input id="phone" type="text" name="phone" required className="bg-white/90 border-2 border-gray-300 rounded-xl py-2 px-4 focus:border-main focus:bg-white focus:shadow-lg focus:outline-none transform hover:-translate-y-1 transition-all duration-300"></input>
                            </Container>

                            <Container className="flex flex-col gap-2" bgColor="transparent">
                            <label className="font-medium text-gray-800">Zpráva</label>
                            <textarea id="message" name="message" className="bg-white/90 border-2 border-gray-300 rounded-xl py-2 px-4 focus:border-main focus:bg-white focus:shadow-lg focus:outline-none transform hover:-translate-y-1 transition-all duration-300 min-h-[120px] resize-y"></textarea>
                            </Container>

                            <Button type="submit">
                                Odeslat
                            </Button>
                        </form>
                    </Container>
                </Container>
            </Container>
        </section>
    )

}